import * as XLSX from "xlsx-js-style";

export function exportToExcel(filename, rows) {
  const header = [
    "FC PRODUCT",
    "BEG. INV",
    "SALES CNT",
    "ENDING",
    "P. COUNT",
    "COSTOFGOODS",
    "IDEAL", // G
    "VARIANT", // H
  ];

  const data = [
    header,
    ...rows.map((r) => [
      r.fcProduct,
      Number(r.beginningInventory) || 0,
      Number(r.saleCount) || 0,
      Number(r.ending) || 0,
      Number(r.pCount) || 0,
      Number(r.costOfGoods) || 0,
      Number(r.ideal) || 0,
      Number(r.variant) || 0,
    ]),
  ];

  const ws = XLSX.utils.aoa_to_sheet(data);

  // Freeze + Autofilter
  ws["!freeze"] = { xSplit: 0, ySplit: 1 };
  ws["!autofilter"] = {
    ref: XLSX.utils.encode_range({
      s: { r: 0, c: 0 },
      e: { r: data.length - 1, c: header.length - 1 },
    }),
  };

  // Column widths
  ws["!cols"] = [
    { wch: 28 },
    { wch: 12 },
    { wch: 10 },
    { wch: 12 },
    { wch: 10 },
    { wch: 12 },
    { wch: 10 },
    { wch: 10 },
  ];

  // Common number format for numeric cols (B..H)
  const numFmtCols = [1, 2, 3, 4, 5, 6, 7];
  for (let r = 1; r < data.length; r++) {
    for (const c of numFmtCols) {
      const addr = XLSX.utils.encode_cell({ r, c });
      if (ws[addr]) {
        ws[addr].z = "#,##0.00";
        ws[addr].s = {
          ...(ws[addr].s || {}),
          alignment: { horizontal: "right" },
        };
      }
    }
  }

  // Header style (dark bg) + custom colors for G/H
  for (let c = 0; c < header.length; c++) {
    const addr = XLSX.utils.encode_cell({ r: 0, c });
    if (!ws[addr]) continue;

    // default header
    ws[addr].s = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F1F1F" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    // override header font color for IDEAL (red) and VARIANT (blue)
    if (c === 6) ws[addr].s.font = { bold: true, color: { rgb: "FF0000" } };
    if (c === 7) ws[addr].s.font = { bold: true, color: { rgb: "0000FF" } };
  }

  // Fixed colors per column:
  // G (IDEAL) -> red text for all values
  // H (VARIANT) -> blue text for all values
  for (let r = 1; r < data.length; r++) {
    const gAddr = XLSX.utils.encode_cell({ r, c: 6 });
    const hAddr = XLSX.utils.encode_cell({ r, c: 7 });
    if (ws[gAddr]) {
      ws[gAddr].s = {
        ...(ws[gAddr].s || {}),
        font: { color: { rgb: "FF0000" }, bold: false },
        alignment: { horizontal: "right" },
      };
    }
    if (ws[hAddr]) {
      ws[hAddr].s = {
        ...(ws[hAddr].s || {}),
        font: { color: { rgb: "0000FF" }, bold: false },
        alignment: { horizontal: "right" },
      };
    }
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "FC_Variant_Export");
  XLSX.writeFile(
    wb,
    filename.endsWith(".xlsx") ? filename : `${filename}.xlsx`
  );
}
